import { Component } from '@angular/core';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-newpwd',
  templateUrl: './newpwd.component.html',
  styleUrls: ['./newpwd.component.scss'],
})
export class NewpwdComponent  {
  hide:boolean;newpass;confirmpass;hide1:boolean;
  constructor(private auth: AuthService,
    public handler: HandlerService,
    public router: Router,
    public service: ApiService) { }


   

    save(){
      this.hide=false;
      this.hide1=false;
      if(this.newpass==this.confirmpass){
          var y = window.btoa(this.confirmpass);
          var post ={
            password: y
          }
      this.service.resetpass(post).subscribe(res => {
        this.handler.res("Password Changed Successfully!!!");
        this.router.navigate(['/bookservice']);
      })
      }
      else{
        this.handler.res("Passwords Does Not Match")
      }
         
    }

    cancel(){
      this.router.navigate(['/vendorLogin']);
    }

    ionViewWillLeave(){
      this.newpass = undefined;
      this.confirmpass = undefined;
    }
    
  }
